import defame from "./defame-potion.png"
import fakeFriends from "./fake-friends-potion.png"
import ignorance from "./ignorance-potion.png"
import illusions from "./illusions-potion.png"
import love from "./love-potion.png"

export default {
  defame,
  fakeFriends,
  ignorance,
  illusions,
  love
}